import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DOCUMENT,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@nx-vigil/core/web/auth/feature';
import { ProgressComponent } from '@nx-vigil/core/web/shared/ui';
import {
  LinkItem,
  NavigationShellComponent,
} from '@nx-vigil/core/web/shell/ui';

@Component({
  selector: 'central-shell-feature-layout',
  imports: [
    CommonModule,
    RouterModule,
    NavigationShellComponent,
    ProgressComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if ((auth.isLoaded$ | async) === true) {
      <core-nav-shell
        [links]="links"
        (login)="login()"
        (logout)="logout()"
        (switchCustomer)="switchCustomer()"
      />
    } @else {
      <core-progress />
    }
  `,
  styles: [],
})
export class CentralShellComponent {
  protected auth = inject(AuthService);
  protected doc = inject<Document>(DOCUMENT);

  protected readonly links: LinkItem[] = [
    {
      label: 'VIGIL',
      href: 'https://www.3xlogic.com/vigil-video-solutions#product-parent-3646',
    },
  ];

  protected login() {
    this.auth.login();
  }

  protected logout() {
    this.auth.logout();
  }

  protected switchCustomer() {
    this.auth.restartLogin();
  }
}
